const BASE_URL = process.env.REACT_APP_BASE_URL;
const NOMAD_COIN_URL = process.env.REACT_APP_NOMAD_COIN_URL;

export function fetchCoins() {
    return fetch(`${BASE_URL}/coins`).then((response) =>
        response.json()
    );
}

export function fetchCoinInfo(coinId: string) {
    return fetch(`${BASE_URL}/coins/${coinId}`).then((response) =>
        response.json()
    );
}

export function fetchCoinTickers(coinId: string) {
    return fetch(`${BASE_URL}/tickers/${coinId}`).then((response) =>
        response.json()
    );
}

export function fetchCoinHistory(coinId: string) {
    const endDate = Math.floor(Date.now()/1000);
    const startDate = endDate - 60*60*24*7*2;
    return fetch(`${NOMAD_COIN_URL}?coinId=${coinId}&start=${startDate}&end=${endDate}`).then((response) =>
        response.json()
    );
}